export default {"src":"https://fishbrain.com/_next/static/media/maine.8c96beb9.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};